/* eslint-disable  no-process-env */
import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import styles from './css/Likes.styl';
import classNames from 'classnames';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {
  getLocalStorage,
  setLocalStorage,
  clearLocalStorage,
} from '../../../../shared/utilities/localStorageHelper';
import {LikesHeart} from '../../../../shared/Svgs';
import {mutateCondolenceLikes} from '../../../../redux/likesHelper';

export class Likes extends React.Component {
  static propTypes = {
    condolenceId: React.PropTypes.number,
    likesCount: React.PropTypes.number,
    mutateCondolenceLikes: React.PropTypes.func,
    sourceId: React.PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      animate: false,
    };

    this.isDisabled = process.env.DISABLE_LIKES === 'true';

    this.initialCount = null;
    this.nextCount = null;
    this.setCount();

    this.timer = null;

    bindMethods(this, ['checkLikeHistory', 'handleClick']);
  }

  componentDidMount() {
    window.addEventListener('keydown', clearLocalStorage);
    this.timer = setTimeout(this.checkLikeHistory, Math.random() * 1000 + 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    window.removeEventListener('keydown', clearLocalStorage);
  }

  /**
   * sets initial and next count. evens up length
   * @param {number} increment  amount to increment initial count
   * @return {Undefined}        returns nothing
   */
  setCount(increment = 1) {
    const count = _.get(this.props, 'likesCount') || 0;
    const initialCount = count.toString().split('');

    this.nextCount = (count + increment).toString().split('');

    if (_.size(initialCount) < _.size(this.nextCount)) {
      initialCount.unshift('0');
    }

    this.initialCount = initialCount;
  }

  /**
   * applies necessary styles for number counts
   * @param {Object} mainStyle style Object
   * @param {number} index     current index
   * @return {Object}          style object
   */
  setStyles(mainStyle, index) {
    const conditionalClasses = {};
    const isMatch = this.initialCount[index] === this.nextCount[index];
    const shouldAnimate = this.state.animate && !isMatch;

    conditionalClasses[styles.animate] = shouldAnimate;
    conditionalClasses[styles[`order${index}`]] = shouldAnimate;

    if (mainStyle === styles.top && index === 0) {
      conditionalClasses[styles.danglingDigit] = this.initialCount[0] === '0';
    }

    return classNames(mainStyle, conditionalClasses);
  }

  /**
   * click handler
   * @return {Undefined} returns nothing
   */
  handleClick() {
    if (!this.state.animate && !getLocalStorage(this.props.condolenceId)) {
      this.props.mutateCondolenceLikes({
        condolenceId: this.props.condolenceId,
      });

      getGATags({
        eventCategory: `bypage_person_${this.props.sourceId}`,
        eventAction: `gb_like_${this.props.condolenceId}`,
        eventLabel: this.props.likesCount + 1,
      });

      setLocalStorage(this.props.condolenceId);
      this.setState({animate: true});
    }
  }

  /**
   * checks like status of condolence
   * @return {undefined} returns nothing
   */
  checkLikeHistory() {
    if (getLocalStorage(this.props.condolenceId)) {
      this.setCount(0);
      this.setState({animate: true});
    }
  }

  render() {
    const {condolenceId, likesCount} = this.props;

    return !this.isDisabled && condolenceId && likesCount >= 0 ? (
      <div className={styles.Likes}>
        <div className={styles.counter}>
          {this.nextCount.map((item, index) => (
            <span className={styles.group} key={index}>
              <div className={this.setStyles(styles.top, index)}>
                {this.initialCount[index]}
              </div>
              <div className={this.setStyles(styles.bottom, index)}>{item}</div>
            </span>
          ))}
        </div>
        <div
          className={`${styles.icon}${
            this.state.animate ? ` ${styles.animate}` : ''
          }`}
          id="likes"
          onClick={this.handleClick}
        >
          <LikesHeart />
        </div>
      </div>
    ) : null;
  }
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  mutateCondolenceLikes: mutationParams => {
    dispatch(mutateCondolenceLikes(mutationParams));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(Likes);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/Likes.js